import React, { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Menus, Link, Text, Icon } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import FormsIcon from '../icons/FormsIcon';

import styles from './styles';
const useStyles = createUseStyles(styles, 'FormsListItem');

function FormsListItem({
    id,
    idFormType,
    pos11,
    pos12,
    pos13,
    pos21,
    pos22,
    pos23,
    readOnly,
    openDetail,
    editForm,
    deleteForm,
    style,
}) {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const items = useMemo(() => {
        const menuItems = [];
        if (editForm)
            menuItems.push({
                title: <Text>{readOnly ? t('action_view') : t('action_edit')}</Text>,
                onClick: () => editForm && editForm(id, idFormType),
            });
        if (deleteForm)
            menuItems.push({
                title: <Text>{t('action_delete')}</Text>,
                onClick: () => deleteForm && deleteForm(id),
            });
        return menuItems;
    }, [t, readOnly, editForm, id, idFormType, deleteForm]);

    const handleOnClick = useCallback(() => {
        openDetail(id);
    }, [id, openDetail]);

    const menusClasses = useMemo(() => ({ subMenu: classes.subMenu }), [classes.subMenu]);

    return (
        <div className={classes.root} style={style}>
            <div className={classes.icons}>
                <div className={classes.formIcon}>
                    <FormsIcon />
                </div>
                {readOnly ? (
                    <div className={classes.lockIcon}>
                        <Icon name="lock" size="small" />
                    </div>
                ) : null}
            </div>
            <div className={classes.lineBlock}>
                <div className={classes.positions}>
                    <div>
                        <Link className={classes.position} onClick={handleOnClick}>
                            {pos11}
                        </Link>
                        <Text className={classes.position}>{pos12}</Text>
                        <Text className={classes.position}>{pos13}</Text>
                    </div>
                    <div>
                        <Text className={classes.position} bold>
                            {pos21}
                        </Text>
                        <Text className={classes.position}>{pos22}</Text>
                        <Text className={classes.position}>{pos23 || id}</Text>
                    </div>
                </div>
                {!!items.length && (
                    <Menus
                        className={classes.menu}
                        icon={<Icon name="threeDots" />}
                        items={items}
                        classes={menusClasses}
                        size="small"
                    />
                )}
            </div>
        </div>
    );
}

FormsListItem.propTypes = {
    id: PropTypes.number.isRequired,
    pos11: PropTypes.string,
    pos12: PropTypes.string,
    pos13: PropTypes.string,
    pos21: PropTypes.string,
    pos22: PropTypes.string,
    pos23: PropTypes.string,
    readOnly: PropTypes.bool,
};

export default memo(FormsListItem);
